import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { DEFAULT_LOOKBACK_DAYS, LOOKBACK_DAYS_OPTIONS } from '../component-sidebar.config';

@Component({
  selector: 'twaice-fe-lookback-select',
  templateUrl: './lookback-select.component.html',
  imports: [FormsModule, NzSelectModule],
})
export class LookbackSelectComponent {
  @Input() lookbackDays = DEFAULT_LOOKBACK_DAYS;

  @Output() lookbackDaysChange = new EventEmitter<number>();

  protected readonly options = LOOKBACK_DAYS_OPTIONS;
}
